<div class="p-4">
    <!-- Überschrift & Button "Neuen Client erstellen" -->
    <div class="flex justify-between items-center mb-4">
      <h2 class="text-2xl font-bold">Client-Verwaltung</h2>
      <button
        pButton
        type="button"
        label="Neuen Client erstellen"
        icon="pi pi-plus"
        class="p-button-sm"
        (click)="showCreateDialog()"
      ></button>
    </div>
  
    <!-- PrimeNG-Tabelle -->
    <p-table
      [value]="clients"
      [paginator]="true"
      [rows]="10"
      class="mb-4 shadow-md rounded-lg"
      [resizableColumns]="true"
      columnResizeMode="fit"
    >
      <ng-template pTemplate="header">
        <tr class="bg-gray-100">
          <th pResizableColumn>Client ID</th>
          <th pResizableColumn>Anzeigename</th>
          <th pResizableColumn>SystemId</th>
          <th pResizableColumn>Aktionen</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-client>
        <tr>
          <td class="px-2 py-1">{{ client.clientApplicationId }}</td>
          <td class="px-2 py-1">{{ client.displayName }}</td>
          <td class="px-2 py-1">{{ client.systemId }}</td>
          <td class="px-2 py-1 space-x-2">
            <!-- Bearbeiten 
            <button
              pButton
              type="button"
              icon="pi pi-pencil"
              class="p-button-text p-button-sm"
              (click)="showEditDialog(client)"
            ></button>-->
            <!-- Secret zurücksetzen -->
            <button
              pButton
              type="button"
              icon="pi pi-refresh"
              class="p-button-text p-button-sm"
              (click)="resetSecret(client)"
            ></button>
            <!-- Löschen -->
            <button
              pButton
              type="button"
              icon="pi pi-trash"
              class="p-button-text p-button-sm p-button-danger"
              (click)="deleteClient(client)"
            ></button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  
    <!-- ─────────────────────────────────────────────────────────────────────── -->
    <!-- Dialog: Neuen Client erstellen -->
    <!-- ─────────────────────────────────────────────────────────────────────── -->
    <p-dialog
      header="Neuen Client erstellen"
      [(visible)]="displayCreateDialog"
      [modal]="true"
      [closeOnEscape]="true"
      [dismissableMask]="true"
      [styleClass]="'w-96'"
    >
      <div class="p-fluid space-y-3">
        <div class="p-field">
          <label for="newClientId" class="ds-field-label">Client ID</label>
          <input
            id="newClientId"
            type="text"
            pInputText
            [(ngModel)]="newClient.clientApplicationId"
            class="w-full"
          />
        </div>
        <div class="p-field">
          <label for="newDisplayName" class="ds-field-label">Anzeigename</label>
          <input
            id="newDisplayName"
            type="text"
            pInputText
            [(ngModel)]="newClient.displayName"
            class="w-full"
          />
        </div>
        <div class="p-field">
          <label for="newSystemId" class="ds-field-label">System-ID</label>
          <input
            id="newSystemId"
            type="number"
            pInputText
            [(ngModel)]="newClient.systemId"
            class="w-full"
          />
        </div>
      </div>
      <div class="mt-6 flex justify-end gap-2">
        <button
          pButton
          type="button"
          label="Abbrechen"
          icon="pi pi-times"
          class="p-button-text"
          (click)="displayCreateDialog=false"
        ></button>
        <button
          pButton
          type="button"
          label="Erstellen"
          icon="pi pi-check"
          (click)="createClient()"
        ></button>
      </div>
    </p-dialog>
  
    <!-- ─────────────────────────────────────────────────────────────────────── -->
    <!-- Dialog: Client bearbeiten -->
    <!-- ─────────────────────────────────────────────────────────────────────── -->
   <!-- <p-dialog
      header="Client bearbeiten"
      [(visible)]="displayEditDialog"
      [modal]="true"
      [closeOnEscape]="true"
      [dismissableMask]="true"
      [styleClass]="'w-96'"
    >
      <div class="p-fluid space-y-3">
        <div class="p-field">
          <label>Client ID</label>
          <input type="text" pInputText [value]="editClient.clientApplicationId" disabled class="w-full opacity-70" />
        </div>
        <div class="p-field">
          <label for="editDisplayName">Anzeigename</label>
          <input
            id="editDisplayName"
            type="text"
            pInputText
            [(ngModel)]="updatedDisplayName"
            class="w-full"
          />
        </div>
        <div class="p-field">
          <label for="newSystemId">System-ID</label>
          <input
            id="newSystemId"
            type="number"
            pInputText
            [(ngModel)]="updatedSystemId"
            class="w-full"
          />
        </div>
      </div>
      <div class="mt-6 flex justify-end gap-2">
        <button
          pButton
          type="button"
          label="Abbrechen"
          icon="pi pi-times"
          class="p-button-text"
          (click)="displayEditDialog=false"
        ></button>
        <button
          pButton
          type="button"
          label="Speichern"
          icon="pi pi-check"
          (click)="updateClient()"
        ></button>
      </div>
    </p-dialog>-->
  </div>
  